export enum ConnectionStatus {
  DISCONNECTED = 'DISCONNECTED',
  CONNECTING = 'CONNECTING',
  CONNECTED = 'CONNECTED',
  ERROR = 'ERROR',
}

export interface Message {
  speaker: 'Client' | 'AI Lawyer';
  text: string;
  timestamp: string;
}

export interface LegalSummary {
  classification: string;
  ipc: string;
  bns: string;
  analysis: string;
}

